const barthumbchart = [
    { "City": "Qitaihe", "Sales": 52827.32 },
    { "City": "Wanxian", "Sales": 16921.576 },
    { "City": "Sanya", "Sales": 22698.396 },
    { "City": "Sanchazi", "Sales": 3262.98 },
    { "City": "Sanming", "Sales": 1458.8 },
    { "City": "Shangmei", "Sales": 11704.476 },
    { "City": "Shanghai", "Sales": 582450.5679999999 },
    { "City": "Shangyu", "Sales": 10672.872 },
    { "City": "Dongfeng", "Sales": 1785.84 },
    { "City": "Dongtai", "Sales": 2789.892 },
    { "City": "Dongning", "Sales": 2706.2 },
    { "City": "East Village", "Sales": 13692.14 },
    { "City": "Donghai", "Sales": 4508.28 },
    { "City": "Dongsheng", "Sales": 12766.068 },
    { "City": "Dongguan", "Sales": 10165.89 },
    { "City": "Dongying", "Sales": 17153.92 },
    { "city": "hub", "sales": 1050.42 },
    { "City": "Fengxian", "Sales": 10309.516 },
    { "City": "Fengrun", "Sales": 82.04 },
    { "City": "Fengzhen", "Sales": 3507.336 },
    { "City": "Linqu", "Sales": 833.7 },
    { "City": "Linshui", "Sales": 21443.1 },
    { "City": "Linjiang", "Sales": 36496.74 },
    { "City": "Linfen", "Sales": 26205.48 },
    { "City": "Linyi", "Sales": 97200.74 },
    { "City": "Linhai", "Sales": 7071.456 },
    { "City": "Linqing", "Sales": 38676.12 },
    { "City": "Dandong", "Sales": 45447.612 },
    { "City": "Danjiangkou", "Sales": 4879.616 },
    { "City": "Lishui", "Sales": 3983.616 },
    { "City": "Yiwu", "Sales": 34511.624 },
    { "City": "Yima", "Sales": 1144.024 },
    { "City": "Wuhai", "Sales": 16096.64 },
    { "City": "Uda", "Sales": 3474.66 },
    { "City": "Lecheng", "Sales": 3241 },
    { "City": "Leshan", "Sales": 12561.892 },
    { "City": "Jiutai", "Sales": 32535.944 },
    { "City": "Jiujiang", "Sales": 29890.7 },
    { "City": "Erdaojiang", "Sales": 4461.24 },
    { "City": "Yunfu", "Sales": 6351.212 },
    { "City": "Yunyang", "Sales": 24699.64 },
    { "City": "Wuchang", "Sales": 3771.46 },
    { "City": "Bozhou", "Sales": 16961.14 },
    { "City": "Xianju", "Sales": 6868.512 },
    { "City": "Xiantao", "Sales": 16600.164 },
    { "City": "Yizheng", "Sales": 8566.628 },
    { "City": "Renqiu", "Sales": 12106.78 },
    { "City": "Remaining", "Sales": 103.04 },
    { "City": "Yuyao", "Sales": 12621.84 },
    { "City": "Foshan", "Sales": 7500.388 },
    { "City": "Jiamusi", "Sales": 63263.34 },
    { "City": "Ylang", "Sales": 26874.82 },
    { "City": "Baoding", "Sales": 124133.1 },
    { "City": "Xinyi", "Sales": 4771.06 },
    { "City": "Xinyang", "Sales": 38849.412 },
    { "City": "Yanzhou", "Sales": 28648.2 },
    { "City": "Eight Steps", "Sales": 241.64 },
    { "City": "Bamiantong", "Sales": 2650.2 },
    { "City": "Princess Ridge", "Sales": 21210.756 },
    { "City": "Liuhe", "Sales": 5775.98 },
    { "City": "Lanzhou", "Sales": 42543.144 },
    { "City": "Lanxi", "Sales": 15169.028 },
    { "City": "Lancy", "Sales": 20877.92 },
    { "City": "Xinghua", "Sales": 7848.652 },
    { "City": "Xingcheng", "Sales": 5233.032 },
    { "City": "Neijiang", "Sales": 43502.788 },
    { "City": "Lengshuijiang", "Sales": 21350.196 },
    { "City": "Lengshuitan", "Sales": 4608.94 },
    { "City": "Lingyuan", "Sales": 11950.596 },
    { "City": "Fengcheng", "Sales": 20989.164 },
    { "City": "Icheon", "Sales": 24.696 },
    { "City": "Qianguo", "Sales": 3903.76 },
    { "City": "Jianguang", "Sales": 1811.32 },
    { "City": "Jagdaqi", "Sales": 1801.324 },
    { "City": "Baotou", "Sales": 43217.524 },
    { "City": "Huazhou", "Sales": 9078.944 },
    { "City": "Beijing", "Sales": 376814.902 },
    { "City": "Beihai", "Sales": 525.672 },
    { "City": "Beibei", "Sales": 5338.06 },
    { "City": "Beipiao", "Sales": 7948.164 },
    { "City": "Crossroads", "Sales": 6417.88 },
    { "City": "Nanjing", "Sales": 8300.068 },
    { "City": "Nanchong", "Sales": 23797.284 },
    { "City": "Nantai", "Sales": 5839.848 },
    { "City": "Nanning", "Sales": 118154.078 },
    { "City": "Nangong", "Sales": 14725.48 },
    { "City": "Nancha", "Sales": 24002.16 },
    { "City": "Nanping", "Sales": 11266.22 },
    { "City": "Nanchang", "Sales": 46190.62 },
    { "City": "Nanzhou", "Sales": 1111.32 },
    { "City": "Nandu", "Sales": 23807.56 },
    { "City": "Nanpiao", "Sales": 3059.868 },
    { "City": "Nantong", "Sales": 26558.504 },
    { "City": "Nanyang", "Sales": 62104.546 },
    { "City": "Nanlong", "Sales": 546 },
    { "City": "Nanma", "Sales": 5940.48 },
]

const dataBasicHistodram = [
    {
      type: 'Appliances',
      sales: 38,
    },
    {
      type: 'Grain & oil',
      sales: 52,
    },
    {
      type: 'fresh fruit',
      sales: 61,
    },
    {
      type: 'Beauty care',
      sales: 145,
    },
    {
      type: 'Baby Products',
      sales: 48,
    },
    {
      type: 'imported food',
      sales: 38,
    },
    {
      type: 'food & drink',
      sales: 38,
    },
    {
      type: 'household',
      sales: 38,
    },
  ];

  const dataconversionrate = [
    {
      action: 'browse the website',
      pv: 50000,
    },
    {
      action: 'put it in the cart',
      pv: 35000,
    },
    {
      action: 'Generate orders',
      pv: 25000,
    },
    {
      action: 'Pay for the order',
      pv: 15000,
    },
    {
      action: 'Seal the deal',
      pv: 8500,
    },
  ];

  const dataCustomColorHistogram = [
    {
      type: '1-3second',
      value: 0.16,
    },
    {
      type: '4-10second',
      value: 0.125,
    },
    {
      type: '11-30second',
      value: 0.24,
    },
    {
      type: '31-60second',
      value: 0.19,
    },
    {
      type: '1-3分',
      value: 0.22,
    },
    {
      type: '3-10point',
      value: 0.05,
    },
    {
      type: '10-30point',
      value: 0.01,
    },
    {
      type: '30+point',
      value: 0.015,
    },
  ];

export { barthumbchart, dataBasicHistodram, dataconversionrate, dataCustomColorHistogram }